// extracted by mini-css-extract-plugin
export default {"label":"Label_label__NKVvw","required":"Label_required__A31cQ"};